import api from '../../api/api'
import url from '../../api/env'
import Utils from '../../utils/Utils'

const getAllStores = async () =>
  api
    .get(`${url.stage.storesCash}?paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getStore = async id =>
  api
    .get(`${url.stage.stores}/${id}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearFoAuthError() : console.log(err)))

const getAllProducts = async (storeId, turnId) =>
  api
    .get(`${url.stage.stores}/${storeId}/turns/${turnId}/items?with_skus=1&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getAllCombos = async company_id =>
  api
    .get(`${url.stage.Combos}?${company_id !== 0 ? `company_id=${company_id}&` : ''}paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getAllClients = async () =>
  api
    .get(`${url.stage.Client_options}?paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getAllPaymentMethods = async () =>
  api
    .get(`${url.stage.paymentMethod_options}?paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getStoreTurns = async id =>
  api
    .get(`${url.stage.Turns_options}?store_id=${id}&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const openStoreTurn = async data =>
  api
    .post(`${url.stage.storeTurns}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const closeStoreTurn = async (id, data) =>
  api
    .put(`${url.stage.storeTurns}/${id}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearFoAuthError() : console.log(err)))

const updateSwitchStore = async (id, data) =>
  api
    .put(`${url.stage.internalCorrelative}/switched/${id}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearFoAuthError() : console.log(err)))
    
const getStoreTurn = async id =>
  api
    .get(`${url.stage.storeTurns}/${id}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearFoAuthError() : console.log(err)))

const getStoreCash = async id =>
  api
    .get(`${url.stage.storesCash}?id=${id}&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearFoAuthError() : console.log(err)))

const getClosedStoreTurn = async id =>
  api
    .get(`${url.stage.storeTurns}/${id}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const productsNotAvailable = async (store_id) =>
  api
    .get(`${url.stage.productsNotAvailable}?per_page=100&low_stock=1&store_id=${store_id}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const saveSell = async data =>
  api
    .post(`${url.stage.sells}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const saveQuote = async data =>
  api
    .post(`${url.stage.quotes}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const saveProject = async data =>
  api
    .post(`${url.stage.projects}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const updateQuote = async (data, quoteId) =>
  api
    .put(`${url.stage.quotes}/${quoteId}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const updateProject = async (data, projectId) =>
  api
    .put(`${url.stage.projects}/${projectId}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const saveOfflineSells = async data =>
  api
    .post(`${url.stage.sellsOffline}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getReceivables = async id =>
  api
    .get(`${url.stage.sellPayments}?store_id=${id}&per_page=5`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getNextPage = async urlNextPage =>
  api
    .get(`${urlNextPage}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const completeSell = async (id, data) =>
  api
    .put(`${url.stage.sellPayments}/${id}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearFoAuthError() : console.log(err)))

const getSells = async (id, turn_id, filter = '', excludeChars = true, sort_type = 'desc') =>
  api
    .get(excludeChars ? `${url.stage.sells}?sort_type=${sort_type}&store_id=${id}&store_turn_id=${turn_id}&per_page=5&invoice=%${encodeURIComponent(filter)}%&sort_by=id&sort_type=desc` : encodeURI(`${url.stage.sells}?sort_type=${sort_type}&store_id=${id}&store_turn_id=${turn_id}&per_page=5&invoice=%${filter}%&sort_by=id&sort_type=desc`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getSellsAllTurns = async (id, turn_id = null, filter = '', excludeChars = true, sort_type = 'desc') =>
  api
    .get(excludeChars ? `${url.stage.sells}?sort_type=${sort_type}&store_id=${id}&per_page=5&invoice=%${encodeURIComponent(filter)}%&sort_by=id&sort_type=desc` : encodeURI(`${url.stage.sells}?sort_type=${sort_type}&store_id=${id}&per_page=5&invoice=%${filter}%&sort_by=id&sort_type=desc`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getQuotes = async (id, turn_id, filter = '', excludeChars, sort_type = 'desc') =>
  api
    .get(excludeChars ? `${url.stage.quotes}?sort_type=${sort_type}&store_id=${id}&store_turn_id=${turn_id}&per_page=5&invoice=%${encodeURIComponent(filter)}%&sort_by=id&sort_type=desc`
      : encodeURI(`${url.stage.quotes}?sort_type=${sort_type}&store_id=${id}&store_turn_id=${turn_id}&per_page=5&invoice=%${filter}%&sort_by=id&sort_type=desc`)
      , {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getQuotesAllTurns = async (id, turn_id = null, filter = '', excludeChars, sort_type = 'desc') =>
  api
    .get(excludeChars ? `${url.stage.quotes}?sort_type=${sort_type}&store_id=${id}&per_page=5&invoice=%${encodeURIComponent(filter)}%&sort_by=id&sort_type=desc`
      : encodeURI(`${url.stage.quotes}?sort_type=${sort_type}&store_id=${id}&per_page=5&invoice=%${filter}%&sort_by=id&sort_type=desc`)
      , {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getProjects = async (id, turn_id, filter = '', excludeChars, sort_type = 'desc') =>
  api
    .get(excludeChars ? `${url.stage.projects}?sort_type=${sort_type}&store_id=${id}&store_turn_id=${turn_id}&per_page=5&invoice=%${encodeURIComponent(filter)}%&sort_by=id&sort_type=desc`
      : encodeURI(`${url.stage.projects}?sort_type=${sort_type}&store_id=${id}&store_turn_id=${turn_id}&per_page=5&invoice=%${filter}%&sort_by=id&sort_type=desc`)
      , {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getProjectstAllTurns = async (id, turn_id = null, filter = '', excludeChars, sort_type = 'desc') =>
  api
    .get(excludeChars ? `${url.stage.projects}?store_id=${id}&per_page=5&invoice=%${encodeURIComponent(filter)}%&sort_by=id&sort_type=${sort_type}`
      : encodeURI(`${url.stage.projects}?store_id=${id}&per_page=5&invoice=%${filter}%&sort_by=id&sort_type=${sort_type}`)
      , {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getSell = async (id) =>
  api
    .get(`${url.stage.sells}/${id}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getInvoiceDocumentUrl = async (id, format = 'PDF') =>
  api
    .get(`${url.stage.sells}/${id}/invoice-document-url?format=${format}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getQuote = async (id) =>
  api
    .get(`${url.stage.quotes}/${id}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getProject = async (id) =>
  api
    .get(`${url.stage.projects}/${id}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const sellDelete = async id =>
  api
    .remove(`${url.stage.sells}/${id}`, {})
    .then(res => res)
    .catch(err => err)

const quoteDelete = async id =>
  api
    .remove(`${url.stage.quotes}/${id}`, {})
    .then(res => res)
    .catch(err => err)

const projectDelete = async id =>
  api
    .remove(`${url.stage.projects}/${id}`, {})
    .then(res => res)
    .catch(err => err)

const getAllDeposits = async id =>
  api
    .get(`${url.stage.deposits}?store_id=${id}&per_page=5`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getDeposit = async id => {
  return api
    .get(`${url.stage.deposits}/${id}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))
}

const storeDeposit = async (id, data) => {
  const depositId = id ? '/' + id : ''
  return api
    .post(url.stage.deposits + depositId, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))
}

const editDeposit = async (id, data) =>
  api
    .put(`${url.stage.deposits}/${id}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearFoAuthError() : console.log(err)))

const searchPresentations = async (storeId, turnId, value, excludeChars, sort_type = 'desc') =>
  api
    .get(
      excludeChars ? `${url.stage.stores}/${storeId}/turns/${turnId}/items?sort_type=${sort_type}&presentation_combo_description=%${encodeURIComponent(value)}%&product_maker=%${encodeURIComponent(value)}%&presentation_description=%${encodeURIComponent(value)}%&product_subcategory=%${encodeURIComponent(value)}%&sku_code=%${encodeURIComponent(value)}%&paginate=0`
        : encodeURI(`${url.stage.stores}/${storeId}/turns/${turnId}/items?sort_type=${sort_type}&presentation_combo_description=%${value}%&product_maker=%${value}%&presentation_description=%${value}%&product_subcategory=%${value}%&sku_code=%${value}%&paginate=0`)
      , {}
    )
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getStoreTurnByUser = async user =>
  api
    .get(`${url.stage.storeTurns}?open_by=${user}&is_open=1&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearFoAuthError() : console.log(err)))

const getTurnById = async id =>
  api
    .get(`${url.stage.Turns_options}?id=${id}&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getRecipes = async (number, identity, store_id, turn_id) =>
  api
    .post(url.stage.recipes, { numero: number, identificacion: identity, store_id, turn_id })
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const updateRecipe = async (data, recipeId, sell_id) =>
  api
    .put(`${url.stage.recipes}/${recipeId}`, {
      data,
      sell_id
    })
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))


const getSuggestedProducts = async data =>
  api
    .post(url.stage.suggestedProduct, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  getAllStores,
  getAllProducts,
  getAllCombos,
  getAllClients,
  getAllPaymentMethods,
  getStoreTurns,
  openStoreTurn,
  getStoreTurn,
  saveSell,
  saveQuote,
  saveProject,
  updateQuote,
  updateProject,
  getSell,
  getInvoiceDocumentUrl,
  getQuote,
  getProject,
  saveOfflineSells,
  getReceivables,
  completeSell,
  getNextPage,
  getSells,
  getSellsAllTurns,
  getQuotes,
  getQuotesAllTurns,
  sellDelete,
  quoteDelete,
  projectDelete,
  getAllDeposits,
  getDeposit,
  storeDeposit,
  updateSwitchStore,
  closeStoreTurn,
  getClosedStoreTurn,
  searchPresentations,
  editDeposit,
  getStoreCash,
  getStoreTurnByUser,
  getTurnById,
  productsNotAvailable,
  getStore,
  getProjects,
  getProjectstAllTurns,
  getRecipes,
  updateRecipe,
  getSuggestedProducts
}
